/**
 * Where the Client Vault lives.
 *
 * The vault is its own app at abstract-studio.com, served from the studio NAS
 * and separate from the portal (see vault-gateway/). The portal only links to
 * it; people sign in there with this same portal account.
 *
 * REACT_APP_VAULT_URL:
 *   home-network test  http://192.168.5.28:8790
 *   live               https://abstract-studio.com
 * Unset, the portal says the vault is on its way instead of linking anywhere.
 */
export const vaultUrl = () => (process.env.REACT_APP_VAULT_URL || '').replace(/\/$/, '')
export const vaultConfigured = () => !!vaultUrl()
